import React from 'react';
import { ArrowRight } from 'lucide-react';
import { steps } from '../mock';

const Steps = ({ onDownload }) => {
  return (
    <section className="bg-[#f6f6f2] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-14">
          <p className="text-sm font-semibold text-[#0e9f6e] mb-3">How it works</p>
          <h2 className="font-display text-4xl sm:text-5xl font-700 text-[#0f1712]">Three taps and you’re paid.</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {steps.map((s) => (
            <div key={s.num} className="bg-white rounded-3xl overflow-hidden border border-[#0f1712]/8 group">
              <div className="aspect-[4/3] overflow-hidden">
                <img src={s.img} alt={s.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-7">
                <span className="font-display text-sm font-700 text-[#0e9f6e]">{s.num}</span>
                <h3 className="font-display text-xl font-600 text-[#0f1712] mt-1">{s.title}</h3>
                <p className="text-sm text-[#0f1712]/55 mt-2 leading-relaxed">{s.text}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-12">
          <button onClick={onDownload} className="inline-flex items-center gap-2 bg-[#0f1712] text-white rounded-xl px-7 py-4 text-sm font-semibold hover:bg-black hover:scale-[1.02] active:scale-95 transition-all">
            Get started <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Steps;
